import { useEffect, useState } from 'react'

import cn from 'classnames'

import styles from './styles.module.scss'
import BackgroundIcon from './icons/background.svg'
import Card1Icon from './icons/card_1-icon.svg'
import Card2Icon from './icons/card_2-icon.svg'
import PrivacyTextIcon from './icons/privacy_text-icon.png'
import PrivacyTextMobileIcon from './icons/privacy_text_mobile-icon.png'
import { ManageMoneyProps } from './manage-money.props'
import { useTranslation } from 'utils/use-translation'

export default function ManageMoneyWallet({ className, ...props }: ManageMoneyProps) {
  const { t } = useTranslation()

  const [windowWidth, setWindowWidth] = useState<number>(0)

  useEffect(() => {
    if (window) {
      setWindowWidth(window.innerWidth)
    }
  }, [])

  return (
    <section className={cn(styles.manage, className)} {...props}>
      <div className={styles.manage__title}>
        <h2>{t('control_your_money')}<span>{t('privacy_security')}</span><br/>
          <img src={windowWidth > 765 ? PrivacyTextIcon : PrivacyTextMobileIcon} alt="privacy text icon" />
        </h2>
        <img className={styles.manage__title__background} src={BackgroundIcon} alt="background icon" />
      </div>

      <div className={styles.manage__content}>
        <div className={cn(styles.card, styles.card_safety)}>
          <img src={Card1Icon} alt="card 1 icon" />
          <p>
            {t('the')} <span className={styles.violet}>{t('user_security')}</span> {t('user_funds_security')}</p>

          <span className={styles.rectangle}></span>
          <span className={styles.rectangle}></span>
          <span className={styles.rectangle}></span>
          <span className={styles.rectangle}></span>
        </div>

        <div className={cn(styles.card, styles.card_security)}>
          <img src={Card2Icon} alt="card 2 icon" />
          <p>
            {t('top_tier_security_info')} <span className={styles.green}>{t('fund_security')}</span> {t('cold_wallet_protection')}</p>
          <span className={styles.rectangle}></span>
          <span className={styles.rectangle}></span>
          <span className={styles.rectangle}></span>
          <span className={styles.rectangle}></span>
        </div>
      </div>
    </section>
  )
}
